<template>
    <div class="page-container">
        <div class="home-container">
            <div class="logo-container">
                <div class="logo-wrapper">
                    <img src="../assets/logo.png" alt="" class="logo">
                </div>
                <div class="hamburger-menu" @click="toggleMenu">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="nav-links" :class="{ 'nav-active': isMenuOpen }">
                    <div class="nav-item" @click="$router.push('/')">首页</div>
                    <div class="nav-item hide-mobile" @click="$router.push('/product')">雾曼技术和产品</div>
                    <div class="nav-item nav-item2" @click="$router.push('/Dynamic')">雾曼动态</div>
                    <div class="nav-item" @click="$router.push('/about')">关于雾曼</div>
                    <div class="nav-item" @click="$router.push('/contact')">联系雾曼</div>
                    <div class="nav-item" @click="$router.push('/Cooperation')">成为合伙人</div>
                    <div class="mobile-consult-button" @click="navigateToConsult">需求咨询</div>
                </div>
                <div class="consult-button desktop-only" @click="navigateToConsult">需求咨询</div>
            </div>
            <div class="info-container">
                <div class="page-title">雾曼动态</div>
            </div>
        </div>
        <div style="width: 1345px;margin: 23px auto;">
            <div style="font-weight: 500;font-size: 13px;color: rgba(0,0,0,0.85);display: flex;">
                <div class="" style="cursor: pointer;" @click="$router.push('/')">
                    雾曼官网
                </div>

                <div class="" style="padding: 0 10px;">
                    {{ ">" }}
                </div>
                <div style="font-weight: 500;font-size: 13px;color: rgba(0,0,0,0.85);">
                    {{ newsDetail.title }}
                </div>
            </div>
        </div>

        <!--       
        <div class="home-container">
            <div class="logo-container">
                <div class="logo-wrapper">
                    <img src="../assets/logo.png" alt="" class="logo">
                </div>
                <div class="nav-links">
                    <div class="nav-item" @click="$router.push('/')">首页</div>
                    <div class="nav-item" @click="$router.push('/Product')">雾曼技术和产品</div>
                    <div class="nav-item nav-item2" @click="$router.push('/Dynamic')">雾曼动态</div>
                    <div class="nav-item" @click="$router.push('/About')">关于雾曼</div>
                    <div class="nav-item" @click="$router.push('/Contact')">联系雾曼</div>
                    <div class="nav-item" @click="$router.push('/Cooperation')">成为合伙人</div>
                </div>
            </div>
        </div> -->
        <div style="width: 1345px;margin: 23px auto;background: #fff;border-radius: 15px;padding: 30px;">
            <div style="" class="news-detail-box">
                <div class="news-detail">
                    <div class="news-content">
                        <h1 class="news-title">{{ newsDetail.title }}</h1>
                        <div class="news-info">
                            <span>发布时间：{{ newsDetail.publishDate }}</span>
                        </div>
                        <div class="news-body markdown-body" v-html="markdownContent"></div>
                    </div>
                </div>
                <div style="display: flex;">
                    <div v-if="prevArticle" @click="goToArticle(prevArticle.contentId)" style="cursor: pointer; display: flex;align-items: center;justify-content: space-between; width: 468px;background: #F5F6F7;border-radius: 7px;
                     padding: 18px 10px;margin: 0 10px 0 0px;">
                        <div>
                            <div style="font-size: 13px;color: #6D7278;font-weight: 400;">
                                上一篇：
                            </div>
                            <div style="color: rgba(0,0,0,0.85);font-size: 15px;font-weight: 500;padding: 6px 0 0 0;">
                                {{ prevArticle.title }}
                            </div>
                        </div>
                        <div
                            style="width: 59px;height: 59px;display: flex;align-items: center;justify-content: center;">
                            <img style="margin: auto;" :src="prevArticle.image" alt="">
                        </div>
                    </div>

                    <div v-if="nextArticle" @click="goToArticle(nextArticle.contentId)" style="cursor: pointer; display: flex;align-items: center;justify-content: space-between; width: 468px;background: #F5F6F7;border-radius: 7px;
                     padding: 18px 10px;margin: 0 0 0 18px;">
                        <div>
                            <div style="font-size: 13px;color: #6D7278;font-weight: 400;">
                                下一篇：
                            </div>
                            <div style="color: rgba(0,0,0,0.85);font-size: 15px;font-weight: 500;padding: 6px 0 0 0;">
                                {{ nextArticle.title }}
                            </div>
                        </div>

                        <div
                            style="width: 59px;height: 59px;display: flex;align-items: center;justify-content: center;">
                            <img style="margin: auto;" :src="nextArticle.image" alt="">
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <!--<div class="Aichat">
            <ChatWidget :defaultOpen="isOpen" />
            <div class="Aitext" @click="openChat">AI小曼</div>
        </div>-->
        <Footer />

    </div>
</template>

<script>
import Footer from '@/components/Footer.vue'

import { marked } from 'marked'

export default {
    name: 'NewsDetail',
    components: {
        Footer
    },
    data() {
        return {
            newsDetail: {},
            prevArticle: null,
            nextArticle: null,
            isMenuOpen: false
        }
    },
    computed: {
        markdownContent() {
            // 如果内容是HTML格式就直接返回，否则用marked解析markdown
            if (this.newsDetail.contentHtml) {
                return this.newsDetail.contentHtml
            }
            return this.newsDetail.content ? marked(this.newsDetail.content) : ''
        }
    },
    watch: {
        // 监听路由参数变化
        '$route.query.id': {
            handler(newId) {
                if (newId) {
                    // 重置文章数据
                    this.newsDetail = {}
                    this.prevArticle = null
                    this.nextArticle = null
                    // 重新获取文章详情
                    this.getNewsDetail(newId)
                }
            },
            immediate: true  // 组件创建时就执行一次
        }
    },
    created() {
        // 移除这部分代码，因为已经在 watch 中处理了
        // const contentId = this.$route.query.id
        // if (contentId) {
        //     this.getNewsDetail(contentId)
        // }
    },
    methods: {
        getNewsDetail(id) {
            this.$http.get(`/cms/content/detail/636460636414021/article/${id}`).then(res => {
                if (res.code === 200) {
                    this.newsDetail = res.data
                    // 获取上一篇和下一篇
                    this.getAdjacentArticles(id)
                }
            }).catch(error => {
                console.error('获取新闻详情失败:', error)
            })
        },
        getAdjacentArticles(currentId) {
            this.$http.get('/cms/content/front-list?pageNum=1&pageSize=100&catalogId=636460636414021').then(res => {
                if (res.code === 200 && res.data.rows) {
                    // 按照发布时间降序排序
                    const articles = res.data.rows.sort((a, b) => {
                        return new Date(b.publishDate) - new Date(a.publishDate)
                    })
                    const currentIndex = articles.findIndex(article => article.contentId === currentId)

                    if (currentIndex > 0) {
                        this.prevArticle = {
                            title: articles[currentIndex - 1].title,
                            contentId: articles[currentIndex - 1].contentId,
                            image: articles[currentIndex - 1].logoSrc || require('../assets/home5.png')
                        }
                    }

                    if (currentIndex < articles.length - 1) {
                        this.nextArticle = {
                            title: articles[currentIndex + 1].title,
                            contentId: articles[currentIndex + 1].contentId,
                            image: articles[currentIndex + 1].logoSrc || require('../assets/home5.png')
                        }
                    }
                }
            }).catch(error => {
                console.error('获取相邻文章失败:', error)
            })
        },
        goToArticle(contentId) {
            if (contentId && contentId !== this.$route.query.id) {
                this.$router.push({
                    path: '/news/detail',
                    query: { id: contentId }
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err
                    }
                })
            }
        },
        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen;
        },
        navigateToConsult() {
            this.$router.push('/contact').then(() => {
                setTimeout(() => {
                    window.scrollTo({
                        top: 1000,
                        behavior: 'smooth'
                    });
                }, 500);
            });
        },
        openChat() {
            console.log(this.isOpen)
            this.isOpen = !this.isOpen
        }
    }
}
</script>
<style>
.news-body p {
    all: initial;
    margin: 5px 0;
    display: block;
    margin-bottom: 1em;
}
</style>

<style scoped>
.mobile-consult-button {
    display: none;
}

.news-detail-box {
    width: 1120px;
    margin: auto;
}

.page-container {
    background: #F5F6F7;
}

.home-container {
    width: 100%;
    height: 380px;
    background-color: #000;
    background-image: url("../assets/coop/coop1.png");
    background-size: cover;
    background-position: center;
}

.logo-container {
    width: 100%;
    height: 70px;
    background: rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(3px);
    padding: 0 55px;
    display: flex;
    align-items: center;
    position: relative;
}

.logo-wrapper {
    position: absolute;
}

.logo {
    width: 251px;
    height: 32px;
    object-fit: contain;
}

.hamburger-menu {
    display: none;
}

.nav-links {
    display: flex;
    color: #FFFFFF;
    font-size: 15px;
    font-weight: 600;
    font-style: normal;
    text-align: center;
    margin: auto;
    height: 68px;
    line-height: 70px;
    cursor: pointer;
}

.nav-item {
    padding: 0 20px;
}

.nav-item2 {
    border-bottom: 2px solid #FFFFFF;
}

.consult-button {
    background: #FFFFFF;
    border-radius: 17px;
    width: 96px;
    height: 32px;
    font-weight: 600;
    font-size: 14px;
    color: #0A2E43;
    line-height: 32px;
    text-align: center;
    position: absolute;
    right: 54px;
}

/* .info-container {
    width: 1120px;
    margin: auto;
    margin: 233px;
} */
.page-title {
    color: #FFFFFF;
    font-size: 52px;
    font-weight: 500;
    margin: 96px 0 0 213px;
}

.info-box {
    width: calc(367px - 13px - 13px);
    padding: 0 13px;
    height: 48px;
    background: #FFFFFF;
    border-radius: 8px;
    line-height: 48px;
}

.info-title {
    font-size: 20px;
    color: #041214;
    font-weight: 500;
    font-style: normal;
}

.info-subtitle {
    color: #041214;
    font-size: 16px;
    font-weight: 400;
    font-style: normal;
}

.info-text {
    font-weight: 500;
    font-size: 56px;
    color: #FFFFFF;
    text-align: left;
    font-style: normal;
    width: 1120px;
}

.contact-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
}

.contact-label {
    color: #FFFFFF;
    font-size: 14px;
    margin-left: 8px;
}

.contact-button {
    border: 1px solid #FFFFFF;
    border-radius: 8px;
    height: 48px;
    width: 158px;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 24px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.contact-button:hover {
    background: rgba(255, 255, 255, 0.1);
}

.contact-button img {
    width: 16px;
    height: 16px;
}

.contact-text,
.contact-icon {
    display: none;
}

/* 添加新闻详情内容的样式 */
.news-detail {
    max-width: 1120px;
    margin: 0 auto;
    padding: 20px;
}

.news-title {
    font-size: 24px;
    margin-bottom: 20px;
}

.news-content {
    line-height: 1.6;
}

.news-info {
    margin-bottom: 24px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.45);
}

.news-body {
    font-size: 15px;
    color: rgba(0, 0, 0, 0.85);
}

.news-body img {
    max-width: 100%;
    height: auto;
    object-fit: contain;
}

/* 添加移动端响应式样式 */
@media screen and (max-width: 768px) {
    .news-detail-box {
        width: auto;
        margin: auto;
    }

    .page-container {
        width: 100%;
        overflow-x: hidden;
    }

    .logo-container {
        height: 50px;
        padding: 0 20px;
    }

    .logo {
        width: 150px;
        height: 20px;
        object-fit: contain;
    }

    .hamburger-menu {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 24px;
        height: 20px;
        position: absolute;
        right: 20px;
        cursor: pointer;
    }

    .hamburger-menu span {
        width: 100%;
        height: 2px;
        background: #FFFFFF;
        transition: 0.3s;
    }

    .nav-links {
        position: fixed;
        top: 50px;
        left: 0;
        width: 100%;
        height: 0;
        background: rgba(0, 0, 0, 0.9);
        flex-direction: column;
        overflow: hidden;
        transition: height 0.3s ease;
    }

    .nav-links.nav-active {
        height: calc(100vh - 50px);
    }

    .nav-item {
        height: 50px;
        line-height: 50px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }

    .desktop-only {
        display: none;
    }

    .mobile-consult-button {
        display: block;
        margin: 20px auto;
        background: #FFFFFF;
        border-radius: 17px;
        width: 90%;
        height: 40px;
        line-height: 40px;
        color: #0A2E43;
        font-weight: 600;
    }

    .page-title {
        font-size: 32px;
        margin: 60px 0 0 20px;
        color: #FFFFFF;
        font-weight: 500;
    }

    /* 新闻详情页面响应式调整 */
    .news-detail {
        padding: 15px;
    }

    .news-title {
        font-size: 20px;
    }

    /* 调整文章导航样式 */
    [style*="width: 1345px"] {
        width: 100% !important;
        padding: 15px;
        margin: 10px auto !important;
    }

    [style*="width: 988px"] {
        width: 100% !important;
    }

    /* 上一篇下一篇文章导航响应式 */
    [style*="width: 468px"] {
        width: 100% !important;
        margin: 10px 0 !important;
    }

    .hide-mobile {
        display: none;
    }
}

[style*="width: 59px;height: 59px;"] img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 4px;
}
</style>